export const DIALS = [
  { n: "Colombia", d: "57" },
  { n: "México", d: "52" },
  { n: "Estados Unidos", d: "1" },
  { n: "España", d: "34" },
  { n: "Argentina", d: "54" },
  { n: "Chile", d: "56" },
  { n: "Perú", d: "51" },
  { n: "Ecuador", d: "593" },
  { n: "Venezuela", d: "58" },
  { n: "Panamá", d: "507" },
];

export function normalizePhone(raw: string, dial: string): string | null {
  let d = raw.replace(/[^\d+]/g, "");
  const intl = d.startsWith("+") || d.startsWith("00");
  d = d.replace(/\D/g, "").replace(/^00/, "");
  if (!intl) {
    d = d.replace(/^0+/, "");
    if (d.length <= 10) d = `${dial}${d}`;
  }
  return d.length >= 8 && d.length <= 15 ? d : null;
}

export function buildMessage(tpl: string, name: string, link: string): string {
  const first = name.trim().split(/\s+/)[0] || "";
  const body = tpl
    .replace(/\{nombre\}/gi, first)
    .replace(/ {2,}/g, " ")
    .replace(/\s+([,!.?;:])/g, "$1")
    .trim();
  return `${body}\n\n${link}`;
}

export function readNumber(key: string): number {
  try {
    return Number(window.localStorage.getItem(key)) || 0;
  } catch {
    return 0;
  }
}

export function writeNumber(key: string, n: number) {
  try {
    window.localStorage.setItem(key, String(n));
  } catch {
    // sin almacenamiento
  }
}
